import { render, staticRenderFns } from "./advertising-disclosures.vue?vue&type=template&id=014c1b98"
import script from "./advertising-disclosures.vue?vue&type=script&lang=js"
export * from "./advertising-disclosures.vue?vue&type=script&lang=js"
import style0 from "./advertising-disclosures.vue?vue&type=style&index=0&id=014c1b98&prod&lang=scss"
import style1 from "../../assets/styles/a11yModal.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports